import React from 'react';
import { FormattedMessage } from 'react-intl';
import { dispatch } from 'pluginServices/store';
import { addAccount } from 'Workspace/Admin/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import { getConnection } from './rtmConnectionRef';
import messages from './messages';
import * as constants from './constants';

/**
 * Calls the RTM provision API and returns the created account, or throws on failure.
 * Keeps the store in sync (addAccount on success, toast on error).
 * Use this when you need the response (e.g. await provisionAccount(account)).
 */
export default async function provisionAccount(account) {
  const connection = getConnection();
  if (!connection) {
    throw new Error('Not connected');
  }
  const payload = {
    type: constants.RTM_IAM_SUBSCRIPTION_USER_PROVISION,
    honorificPrefix: account.honorificPrefix,
    givenName: account.givenName,
    familyName: account.familyName,
    email: account.email,
    password: account.password,
    roles: account.roles,
    ...(account.authenticationType != null && account.authenticationType !== '' && { authenticationType: account.authenticationType }),
    ...(account.region != null && account.region !== '' && { region: account.region }),
    ...(account.pearsonId != null && account.pearsonId !== '' && { pearsonId: account.pearsonId }),
  };
  const response = await connection.fetch(payload);
  if (response.type === constants.RTM_IAM_SUBSCRIPTION_USER_PROVISION_OK) {
    const result = response.response.account;
    dispatch(addAccount(result));
    return result;
  }
  dispatch(
    pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceAccountCreate} />,
    })
  );
  throw new Error('Account creation failed');
}
